import { Component, OnInit } from '@angular/core';
import { EidosInputBaseComponent } from '@common/components/entities/inputs/eidos-input-base.component';

@Component({
  selector: 'eidos-input-checkbox',
  templateUrl: './eidos-input-checkbox.component.html',
  styleUrls: ['./eidos-input-checkbox.component.scss']
})
export class EidosInputCheckboxComponent extends EidosInputBaseComponent<boolean | null | undefined> implements OnInit {
  
  constructor() {
    super();
  }
}